import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class BenefitsService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

    /**
   * Description: Método que llama el servicio web que obtiene los beneficios
   * Autor: Steven Sterling 
   * @param N/A
   * @return Listado de beneficios 
   */
  getBenefitsList() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_BENEFITS_LIST, '');
  }
}
